import { ReactNode } from 'react';
import { TeamHighLevelFilters } from '@/components/team/filters/TeamHighLevelFilters';
import { LayoutWithFilters } from '../LayoutWithFilters';

export const TeamLayoutWithFilters = ({ children }: { children: ReactNode }) => (
  <LayoutWithFilters filters={<TeamHighLevelFilters />}>{children}</LayoutWithFilters>
);
